
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.86.645a.465.465 0 00-.298-.094.496.496 0 00-.374.165L4.125 7.778 1.768 5.677a.477.477 0 00-.33-.135.473.473 0 00-.335.135l-.305.287a.4.4 0 00-.137.311c0 .126.046.231.137.317l2.935 2.771a.732.732 0 00.79.124.624.624 0 00.236-.182L11.27 1.52a.444.444 0 00.106-.276.401.401 0 00-.186-.346l-.33-.253zm-2.4 7.098c-.187-.11-.365-.22-.535-.329a.434.434 0 00-.311-.111.462.462 0 00-.355.147l-.286.305a.432.432 0 00.013.616l1.057.992a.68.68 0 00.485.188.717.717 0 00.541-.246l6.486-7.762a.399.399 0 00.106-.275.441.441 0 00-.174-.347L15.139.67a.455.455 0 00-.293-.094.489.489 0 00-.367.164L8.46 7.743z","fill":"#000"}})])
          )
        }
      }
    